import moment from "moment";
import filter from "lodash/filter";
import { NUMBER_DAY } from "../models";
import * as utils from "vino/utils";

export const checkDayIsAvailable = (date, slots, eventPackage) => {
	const dt = moment(date);
	let { startDate, endDate } = eventPackage;
	if (startDate) {
		startDate = moment(startDate);
	} else {
		startDate = moment(new Date().fp_incr(1));
	}
	if (endDate) {
		endDate = moment(endDate);
	} else {
		endDate = moment().year(moment().year() + 2);
	}

	if (dt > startDate && dt <= endDate) {
		if (slots.length === 0) {
			return false;
		}
		const day = getDay(date);

		const results = filter(slots, { day });
		const haveSlot = results.length > 0;
		return haveSlot;
	}
	return false;
};

export const getTimeSlotsByDay = (date, slots) => {
	const day = getDay(date);
	return utils.getTimeSlotsByDay(day, slots);
};

const getDay = (date) => {
	const dt = moment(date);
	const dayNumber = dt.weekday();
	return NUMBER_DAY[dayNumber];
};
